import { all, call, put, select } from 'redux-saga/effects';
import cirrusClient from '../../../services/api/cirrus-client';
import { setLoading, setNewVoicemail, setSavedVoicemail } from '../../../state/voicemail/voicemailSlice';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';

export function* fetchVoicemailSaga() {
    yield put(setLoading(true));
    try {

        // Fetch user credentials from Redux store
        const { user, domain } = yield select(selectUserCredentials);

        // API endpoint for retrieving voicemail (relative URL)
        const apiUrl = '?object=audio&action=read';
        // Parameters for the API call
        const commonParams = {
            user: user,
            domain: domain,
            format: 'json',
            count: 200,
            limit: 200,
            intArray: 'true',
            type: 'vmail/new',
        };

        // Make the API call with the credentials
        const [newVoicemailResponse, savedVoicemailResponse] = yield all([
            call(cirrusClient.get, apiUrl, { params: { ...commonParams, type: 'vmail/new' } }),
            call(cirrusClient.get, apiUrl, { params: { ...commonParams, type: 'vmail/save' } })
        ]);
        // Process new voicemail data
        const newVoicemail = newVoicemailResponse.data.map((voicemail) => {
            voicemail.remotepath = voicemail.remotepath.replace('local.netsapiens.com', 'corp.netsapiens.com')
                .replace(/&amp;/g, '&')
                .replace(/%40/g, '@');
            voicemail.index = voicemail.index?.split('.')[0]; // Handle index split
            voicemail.vmail_type = 'vmail/new'; // Add voicemail type

            return voicemail;
        });

        // Process saved voicemail data
        const savedVoicemail = savedVoicemailResponse.data.map((voicemail) => {
            voicemail.remotepath = voicemail.remotepath.replace('local.netsapiens.com', 'corp.netsapiens.com')
                .replace(/&amp;/g, '&')
                .replace(/%40/g, '@');
            voicemail.index = voicemail.index?.split('.')[0]; // Handle index split
            voicemail.vmail_type = 'vmail/save'; // Add voicemail type

            return voicemail;
        });
        // Dispatch both responses to the Redux store
        yield put(setNewVoicemail(newVoicemail));
        yield put(setSavedVoicemail(savedVoicemail));
        yield put(setLoading(false));
    } catch (error) {
        yield put(setLoading(false));
        console.error('Error fetching voicemail:', error);
    }
}
